import { BrandMediaInfo, getPrimaryImage, isMediaTypeImage, PropertyMediaInfo } from '@miq/utils';

export interface MediaInformation {
  getMediaInformation: () => PropertyMediaInfo[] | BrandMediaInfo[];
}

export const withAssociationMedia = (): MediaInformation => {
  function getMediaInformation() {
    return this.property.property_media_information;
  }
  return { getMediaInformation };
};

export const withPropertyMedia = (): MediaInformation => {
  function getMediaInformation() {
    return this.property_media_information;
  }
  return { getMediaInformation };
};

/**
 * Look and return the primary or the newest image —this later depending on its media ID.
 *
 * check getMediaInformation from the composer which returns Array of media
 * @return {PropertyMediaInfo} Primary or latest image
 */
export const withPrimaryImage = () => {
  function getPrimaryOrFirstImageFromRecord() {
    const recordMediaInfo = this.getMediaInformation();
    let image = getPrimaryImage(recordMediaInfo);
    if (!image && recordMediaInfo.length) {
      const sortedImages = ((Array.isArray(recordMediaInfo) && recordMediaInfo) || [])
        .filter(isMediaTypeImage)
        .sort((imageA, imageB) => imageB.id - imageA.id);
      image = sortedImages.length > 0 ? sortedImages[0] : null;
    }
    return image;
  }
  return { getPrimaryOrFirstImageFromRecord };
};
